var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner",
      attrs: {
        id: "app",
        visible: _vm.innerVisible,
        title: _vm.title,
        width: "1000px",
        "close-on-click-modal": false,
        "append-to-body": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: function($event) {
          return _vm.closeHandler()
        }
      }
    },
    [
      _c("warehouse-detail-grid", {
        ref: "detailGrid",
        attrs: {
          action: _vm.action,
          context: _vm.context,
          job: _vm.job,
          "warehouse-in": _vm.warehouse,
          "open-imperial": _vm.openImperial
        }
      }),
      _c(
        "div",
        {
          staticStyle: { "text-align": "right", "margin-top": "15px" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { no: "1", type: "primary" },
              on: { click: _vm.enterHandler }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.ok")) + " ")]
          ),
          _c(
            "el-button",
            { attrs: { no: "2" }, on: { click: _vm.closeHandler } },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }